import SideBarButton from "../../components/SideBarButton";
import { connect } from "react-redux";
import { logout } from "../actions/authActions";

const mapDispatchToProps = (dispatch) => ({
  logoutUser: () => dispatch(logout()),
});

export default connect(null, mapDispatchToProps)(SideBarButton);
